export default {
    NONE: {
        id: 'None',
        description: 'No authentication'
    },
    OAUTH2CLIENTCREDENTIALS: {
        id: 'OAuth2ClientCredentials',
        description: 'OAuth2 Client Credentials'
    },
    OAUTH2PASSWORDFLOW: {
        id: "OAuth2PasswordFlow",
        description: 'OAuth2 Password Flow'
    }
}


// WEBPACK FOOTER //
// ./src/modules/organization/models/NotificationChannelHttpAuthenticationType.ts